"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCTS_DATA = void 0;
const content = `
    shortDescription
`;
const magentoBundleOptions = `
    id
    quantity
    value
`;
const attributeSets = `
    size
    comfortLevel
    mattressHeight
    sidePanel
    chairOption
    quiltOption
    color
    fabric
    material
    foundationHeight
    pillowHeightOption
    bathSet
    scent
`;
const attribute = `
    code
    value
    label
`;
const bundleVariant = `
    productCode
    quantity
    sku
`;
const variant = `
    sku
    productCode
    name
    genericName
    category
    subcategory
    productUrl
    variantUrl
    price
    size
    comfortLevel
    mattressHeight
    sidePanel
    chairOption
    quiltOption
    pillowHeightOption
    bathSet
    color
    scent
    fabric
    material
    fabricMaterial
    foundationHeight
    magentoProductType
    attributes {
        ${attribute}
    }
    inStock
    magentoBundleOptions {
        ${magentoBundleOptions}
    }
    hiddenAttributeValues {
        ${attributeSets}
    }
    bundledSkus
    bundledVariants {
        ${bundleVariant}
    }
    assets {
        ardad {
          descriptor
          folder
          filenameBase
          fileExt
        }
    }
`;
const product = `
    productCode
    name
    active
    category
    subcategory
    defaultPrice
    lowestPrice
    highestPrice
    attributeSets {
        ${attributeSets}
    }
    url
    content {
        ${content}
    }
    isBundleProduct
    relationships {
        relationshipLabel
        relatedProductCodes
    }
    variants {
        ${variant}
    }
    magentoProductType
    options {
        code
        displayName
        displayType
        default
        values {
            code
            label
            swatch
        }
    }
    configurableAttributes
`;
exports.GET_PRODUCTS_DATA = `
    query ($productCodes: [String!]!, $modifiers: [ProductModifier]) {
        products(productCodes: $productCodes, modifiers: $modifiers) {
            ${product}
        }
    }
`;
//# sourceMappingURL=queries.js.map